module.exports = __webpack_public_path__ + "img/red.5f2fc207.jpg";